import axios from 'axios';

axios.defaults.withCredentials = true;

export const gsc = () => axios.get('/gsc');
export const getTsConfigData = () => axios.post( '/hotelconfig/tsconfigdata');